import React, { useLayoutEffect, useRef, useState } from "react";
import classes from "./bottomButton.module.scss";
import { Link } from "react-router-dom";
import StandardButton from "../buttons/standard.button.jsx";

/**
 * Dieser Wrapper ist für Content, der Scrollbar sein soll und wo unten dran ein Button ist,
 * der aber immer dran ist, also absolute.
 * Die Seite hat unten ein Padding, sodass wenn sie zuende gescrollt ist, liegt der Button nicht über dem Content.
 * @param children
 * @param {[BottomButton]}buttons
 * @param className
 * @return {JSX.Element}
 * @constructor
 */
export function BottomButtonContainer({
  children,
  buttons = [],
  className = "mw-35-rem",
  buttonClassName = "d-flex justify-content-center",
}) {
  // States
  const [buttonContainerHeight, setButtonContainerHeight] = useState(0);

  // Refs
  const buttonContainer = useRef();

  // Part Components
  const getButtons = () => {
    return buttons.map((b, index) => {
      let button = (
        <StandardButton
          key={index}
          disabled={b.disabled}
          loadingWhenDisabled={b.loading}
          buttonClasses={"pr-5 pl-5 " + b.className}
          handleClick={b.onClick}
        >
          {b.text}
        </StandardButton>
      );
      if (!b.pathname) {
        return button;
      } else {
        return (
          <Link
            key={index}
            to={{
              pathname: b.pathname,
              state: b.state,
            }}
          >
            {button}
          </Link>
        );
      }
    });
  };

  // Effects
  useLayoutEffect(() => {
    // Sorgt dafür, dass die Buttonhöhe als Padding an den Container drangesetzt wird
    setButtonContainerHeight(buttonContainer.current.clientHeight);
  }, []);

  return (
    <div
      className={`${classes.main} ${className} pointer-event-on no-scrollbar overflow-hidden position-relative h-100 pb-5`}
    >
      <div
        style={{ paddingBottom: buttonContainerHeight }}
        className={"overflow-auto h-100 d-flex flex-column"}
      >
        {children}
      </div>
      <div
        className={classes.lowerContainer + " " + buttonClassName}
        ref={buttonContainer}
      >
        {getButtons()}
      </div>
    </div>
  );
}

/**
 * Zur gescheiten Übergabe von Parametern für die Buttons
 */
export class BottomButton {
  constructor(
    onClick = () => {},
    text = "",
    {
      disabled = false,
      className = "",
      pathname = "",
      state = {},
      loading = false,
    } = {}
  ) {
    this.onClick = onClick;
    this.text = text;
    this.disabled = disabled;
    this.className = className;
    this.pathname = pathname;
    this.state = state;
    this.loading = loading;
  }
}
